import './css/stylesheet.css';
import './fonts/fontsheet.css';

function Desktop({ children }){
    return (
        <div className="desktop" style={{flex: "1 1 auto", backgroundColor: "#808080"}}>
            { children }
        </div>
    )
}

export default Desktop;